import { useEffect, useState } from "react";
import { BACKEND_URL, makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast} from "../../utils/toastUtils";
import NoData from "../../utils/DataNotFound";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import profile from "../../assets/img/profile.jpg";

export default function MyAgents() {
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [loading, setLoading] = useState(true);

    const [serviceId, setServiceId] = useState("");
    const [timeFilter, setTimeFilter] = useState(""); // "" = All Time, "week", "month", "year"
    const [pageNo, setPageNo] = useState(1);
    const pageSize = 10;
    const [totalPages, setTotalPages] = useState(1);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedAgentId, setSelectedAgentId] = useState(null);


    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [excelModalOpen, setExcelModalOpen] = useState(false);

    const [search, setSearch] = useState("");
    const status = "approved"; // Fixed for this page

    const fetchJobQueries = async () => {
        try {
            setLoading(true);
            const res = await makeRequestAuth(
                "post",
                "/admin/getSerciveJobsList",
                {
                    pageNo,
                    size: pageSize,
                    search,
                    status,
                    serviceId,
                    timeFilter,
                }
            );

            if (res?.error) {
                showErrorToast(res.message || "Failed to fetch job queries");
                setData([]);
                return;
            }

            setData(res?.data?.list || []);
            setTotalPages(Math.ceil((res?.data?.total || 0) / pageSize));
        } catch (err) {
            showErrorToast("Something went wrong");
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchServices = async () => {
        try {
            const res = await makeRequestAuth(
                "post",
                "/admin/getListServiceCategory",
                {}
            );

            if (!res?.error) {
                setServiceList(res.data?.list || []);
            }
        } catch (err) {
            setServiceList([]);
        }
    };

    useEffect(() => {
        fetchServices();
    }, []);

    useEffect(() => {
        const timer = setTimeout(fetchJobQueries, 200);
        return () => clearTimeout(timer);
    }, [pageNo, search, serviceId, timeFilter]);

    const handleExcelDownload = async () => {
        setExcelModalOpen(false);
        const { token } = JSON.parse(sessionStorage.getItem("user")) || {}
        if (!token) return

        if (data.length === 0) {
            showErrorToast(
                "No records found. Try clearing the filters or changing your search, then download again."
            );
            return
        }
        try {
            const res = await axios.post(
                BACKEND_URL + "/admin/exportServicAgentExcel",
                {
                    search,
                    status,
                    serviceId,
                    timeFilter,
                    startDate,
                    endDate,    
                },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res.data.type === "application/json") {
                const text = await res.data.text();
                const json = JSON.parse(text);

                if (json.error) {
                    return showErrorToast(json.message);
                }
            }

            const fileBlob =
                res instanceof Blob
                    ? res
                    : res?.data instanceof Blob
                        ? res.data
                        : new Blob([res], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });


            const url = window.URL.createObjectURL(fileBlob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `Approved_Agents_${Date.now()}_sheet.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            showErrorToast("Excel download failed");
        }
    };


    const prevPage = () => pageNo > 1 && setPageNo((p) => p - 1);
    const nextPage = () => pageNo < totalPages && setPageNo((p) => p + 1);
       const handleSettleCOD = async () => {
        if (!selectedAgentId) return;

        const { token } = JSON.parse(sessionStorage.getItem("user")) || {};
        if (!token) return;

        try {
            const response = await axios.post(`${BACKEND_URL}/admin/clearAgentCOD`, {
                agentId: selectedAgentId
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            if (response.data.status === 1) {
                // Yahan Success Toast aa gaya
                showSuccessToast("Cash settled successfully!"); 
                setShowConfirmModal(false); // Modal band kar do
                setSelectedAgentId(null);
                fetchJobQueries(); // Table ko refresh kar do
            }
        } catch (error) {
            console.error("Error settling cash:", error);
            showErrorToast("Settle nahi ho paya, kuch error hai."); // Error Toast
        }
    };




    return (
        <div className="p-6 min-h-screen bg-white">
            <ToastContainer />

            {/* HEADER */}
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-semibold text-[#434646]">
                    My Approved Agents
                </h2>

                <button
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 rounded-xl border border-[#24ADD7] text-[#24ADD7]
          hover:bg-[#24ADD7] hover:text-white transition"
                >
                    ← Back
                </button>
            </div>

            {/* FILTER BAR */}
            <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6 shadow-sm">
                <div className="flex flex-wrap gap-4 items-end">

                    {/* 🔍 SEARCH */}
                    <div className="relative flex-1 min-w-[220px]">
                        <input
                            type="text"
                            placeholder="Search name / phone / email"
                            value={search}
                            onChange={(e) => {
                                setPageNo(1);
                                setSearch(e.target.value);
                            }}
                            className="pl-10 pr-4 py-2 border border-gray-200 rounded-xl w-full
              text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                        />
                        <svg
                            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>

                   {/* 📅 TIME FILTER DROPDOWN */}
<select
    value={timeFilter}
    onChange={(e) => {
        setPageNo(1);
        setTimeFilter(e.target.value);
    }}
    className="px-4 py-2 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
>
    <option value="">All Time</option>
    <option value="week">This Week (Last 7 Days)</option>
    <option value="month">This Month (Last 30 Days)</option>
    <option value="year">This Year (Last 365 Days)</option>
</select>

                    <button
                        disabled={data.length === 0}
                        onClick={() => setExcelModalOpen(true)}
                        className="px-5 py-2 rounded-xl text-sm font-semibold
  bg-[#24ADD7] text-white hover:bg-orange-600 transition"
                    >
                        ⬇ Download Excel
                    </button>

                    {(search || serviceId) && (
                        <button
                            onClick={() => {
                                setSearch("");
                                setServiceId('')
                                setPageNo(1);
                            }}
                            className="px-4 py-2 rounded-xl text-sm font-semibold
              border border-[#24ADD7] text-[#24ADD7]
              hover:bg-[#24ADD7] hover:text-white transition"
                        >
                            Clear All
                        </button>
                    )}
                </div>
            </div>

            {/* LOADING */}
            {loading && (
                <div className="text-center py-20 text-gray-500 font-semibold">
                    Loading approved agents...
                </div>
            )}

            {/* TABLE */}
            <div className="overflow-x-auto bg-white rounded-2xl shadow-xl border border-gray-100">
                <table className="w-full min-w-[700px]">
                    <thead className="bg-gradient-to-r from-[#24ADD7] to-orange-500">
    <tr>
        <th className="p-4 text-left text-white text-sm w-[5%]">#</th>
        <th className="p-4 text-left text-white text-sm w-[10%]">Profile</th>
        <th className="p-4 text-left text-white text-sm w-[10%]">Date</th>
        <th className="p-4 text-left text-white text-sm w-[15%]">Name</th>
        <th className="p-4 text-left text-white text-sm w-[15%]">Phone</th>
        <th className="p-4 text-left text-white text-sm w-[20%]">Email</th>
        <th className="p-4 text-left text-white text-sm w-[25%]">Service</th>
    </tr>
</thead>


                    <tbody className="divide-y divide-gray-100">
                        {!loading && data.length > 0 ? (
                            data.map((item, key) => (
                                <tr key={item._id} className="hover:bg-orange-50/50">
                                    <td className="p-3 font-semibold text-[#434646]">
                                        {key + 1 + (pageNo - 1) * pageSize}.
                                    </td>

                                    <td className="p-3">
                                        <img
                                            src={item.image || profile}
                                            alt={item.name || "image"}
                                            onClick={() => navigate(`/services/agent-profile/${item._id}`)}
                                            className="w-12 h-12 rounded-full object-cover border border-gray-200 cursor-pointer hover:scale-110 transition-transform"
                                        />
                                    </td>

                                    <td className="p-3 text-[#434646] text-sm">
                                        {item.createdAt
                                            ? new Date(item.createdAt).toLocaleDateString()
                                            : "-"}
                                    </td>
                                    <td className="p-3 font-semibold text-[#434646]">
                                        <button 
                                            onClick={() => navigate(`/services/agent-profile/${item._id}`)}
                                            className="hover:text-[#24ADD7] transition-colors"
                                        >
                                            {item.name}
                                        </button>
                                    </td>
                                    <td className="p-3 text-[#434646]">{item.phone}</td>
                                    <td className="p-3 text-[#434646]">{item.email}</td>
<td className="p-4 text-[#434646] font-medium">
    {(() => {
        // Ek chota function jo check karega ki naam asli hai ya raw ID
        const isValidName = (str) => typeof str === "string" && str.length !== 24;

        if (Array.isArray(item?.serviceType) && item.serviceType.length > 0) {
            const names = item.serviceType
                .map(s => (typeof s === 'object' ? s?.name : isValidName(s) ? s : null))
                .filter(Boolean);
            return names.length > 0 ? names.join(", ") : (item?.customServiceType || "Category Deleted");
        } 
        
        if (item?.serviceType?.name) {
            return item.serviceType.name;
        } 
        
        if (Array.isArray(item?.serviceTypeArray) && item.serviceTypeArray.length > 0) {
            const names = item.serviceTypeArray.filter(isValidName);
            return names.length > 0 ? names.join(", ") : (item?.customServiceType || "Category Deleted");
        }

        return item?.customServiceType || "-";
    })()}
</td>


                                </tr>
                            ))
                        ) : (
                            !loading && (
                                <tr>
                                    <td colSpan={7} className="text-center py-10">
                                        <NoData />
                                    </td>
                                </tr>
                            )
                        )}

                    </tbody>
                </table>
            </div>

            {/* PAGINATION */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-4 mt-6 p-3 bg-white rounded-2xl shadow-lg border">
                    <button
                        onClick={prevPage}
                        disabled={pageNo === 1}
                        className="px-4 py-2 border-2 border-[#24ADD7] rounded-xl
            text-[#24ADD7] disabled:opacity-50 hover:bg-[#24ADD7] hover:text-white"
                    >
                        ← Prev
                    </button>

                    <span className="font-semibold text-[#434646]">
                        Page {pageNo} of {totalPages}
                    </span>

                    <button
                        onClick={nextPage}
                        disabled={pageNo === totalPages}
                        className="px-4 py-2 border-2 border-[#24ADD7] rounded-xl
            text-[#24ADD7] disabled:opacity-50 hover:bg-[#24ADD7] hover:text-white"
                    >
                        Next →
                    </button>
                </div>
            )}
                        {/* Custom Confirm Modal */}
            {showConfirmModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-2xl shadow-xl w-96 text-center">
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Confirm Settlement</h3>
                        <p className="text-gray-600 mb-6">Kya aap sach me is agent ka cash settle karna chahte hain?</p>
                        <div className="flex justify-center gap-4">
                            <button
                                onClick={() => setShowConfirmModal(false)}
                                className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg font-semibold hover:bg-gray-300 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSettleCOD}
                                className="px-4 py-2 bg-green-500 text-white rounded-lg font-semibold hover:bg-green-600 transition"
                            >
                                Yes, Settle
                            </button>
                        </div>
                    </div>
                </div>
            )}


{excelModalOpen && (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
        <div className="bg-white rounded-2xl w-full max-w-md overflow-hidden shadow-2xl p-6">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-extrabold text-slate-800">Download Excel</h3>
                <button
                    onClick={() => setExcelModalOpen(false)}
                    className="text-gray-400 hover:text-red-500 transition-colors"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
            </div>
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">Start Date</label>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    />
                </div>
                <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-1">End Date</label>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 text-sm text-[#434646] focus:border-[#24ADD7] outline-none"
                    />
                </div>
            </div>
            <div className="flex justify-end gap-3 mt-8">
                <button
                    onClick={() => setExcelModalOpen(false)}
                    className="px-5 py-2.5 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 hover:bg-gray-50 transition-all"
                >
                    Cancel
                </button>
                <button
                    onClick={handleExcelDownload}
                    className="px-6 py-2.5 bg-[#24ADD7] text-white rounded-xl text-sm font-black hover:bg-[#198cae] transition-all shadow-lg shadow-cyan-100"
                >
                    Download
                </button>
            </div>
        </div>
    </div>
)}

        </div>
        
    );
}
